export const GET_COMPAY_BONUSES_START = 'GET_COMPAY_BONUSES_START';
export const GET_COMPAY_BONUSES_SUCCESS = 'GET_COMPAY_BONUSES_SUCCESS';
export const GET_COMPAY_BONUSES_FAIL = 'GET_COMPAY_BONUSES_FAIL';

export const POST_CREATE_COMPANY_START = 'POST_CREATE_COMPANY_START';
export const POST_CREATE_COMPANY_SUCCESS = 'POST_CREATE_COMPANY_SUCCESS';
export const POST_CREATE_COMPANY_FAIL = 'POST_CREATE_COMPANY_FAIL';

export const DELETE_COMPANY_START = 'DELETE_COMPANY_START';
export const DELETE_COMPANY_SUCCESS = 'DELETE_COMPANY_SUCCESS';
export const DELETE_COMPANY_FAIL = 'DELETE_COMPANY_FAIL';

export const GET_BRANCHES_BONUSES_START = 'GET_BRANCHES_BONUSES_START';
export const GET_BRANCHES_BONUSES_SUCCESS = 'GET_BRANCHES_BONUSES_SUCCESS';
export const GET_BRANCHES_BONUSES_FAIL = 'GET_BRANCHES_BONUSES_FAIL';

export const GET_PACKAGES_START = 'GET_PACKAGES_START';
export const GET_PACKAGES_SUCCESS = 'GET_PACKAGES_SUCCESS';
export const GET_PACKAGES_FAIL = 'GET_PACKAGES_FAIL';

export const CREATE_SERVICE_START = 'CREATE_SERVICE_START';
export const CREATE_SERVICE_SUCCESS = 'CREATE_SERVICE_SUCCESS';
export const CREATE_SERVICE_FAIL = 'CREATE_SERVICE_FAIL';

export const DELETE_SERVICE_START = 'DELETE_SERVICE_START';
export const DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS';
export const DELETE_SERVICE_FAIL = 'DELETE_SERVICE_FAIL';

export const CREATE_CARD_START = 'CREATE_CARD_START';
export const CREATE_CARD_SUCCESS = 'CREATE_CARD_SUCCESS';
export const CREATE_CARD_FAIL = 'CREATE_CARD_FAIL';

export const UPLOAD_FILE_START = 'UPLOAD_FILE_START';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAIL = 'UPLOAD_FILE_FAIL';

export const DELETE_FILE_START = 'DELETE_FILE_START';
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
export const DELETE_FILE_FAIL = 'DELETE_FILE_FAIL';

export const GET_EVENTS_START = 'GET_EVENTS_START';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const GET_EVENTS_FAIL = 'GET_EVENTS_FAIL';

export const GET_EVENT_START = 'GET_EVENT_START';
export const GET_EVENT_SUCCESS = 'GET_EVENT_SUCCESS';
export const GET_EVENT_FAIL = 'GET_EVENT_FAIL';

export const GET_COPY_EVENT_START = 'GET_COPY_EVENT_START';
export const GET_COPY_EVENT_SUCCESS = 'GET_COPY_EVENT_SUCCESS';
export const GET_COPY_EVENT_FAIL = 'GET_COPY_EVENT_FAIL';

export const GET_TRIGGERS_START = 'GET_TRIGGERS_START';
export const GET_TRIGGERS_SUCCESS = 'GET_TRIGGERS_SUCCESS';
export const GET_TRIGGERS_FAIL = 'GET_TRIGGERS_FAIL';

export const PATCH_UPDATE_EVENT_START = 'PATCH_UPDATE_EVENT_START';
export const PATCH_UPDATE_EVENT_SUCCESS = 'PATCH_UPDATE_EVENT_SUCCESS';
export const PATCH_UPDATE_EVENT_FAIL = 'PATCH_UPDATE_EVENT_FAIL';

export const PATCH_SET_ARCHIVED_CARD_START = 'PATCH_SET_ARCHIVED_CARD_START';
export const PATCH_SET_ARCHIVED_CARD_SUCCESS = 'PATCH_SET_ARCHIVED_CARD_SUCCESS';
export const PATCH_SET_ARCHIVED_CARD_FAIL = 'PATCH_SET_ARCHIVED_CARD_FAIL';

export const GET_CMS_PACKAGES_START = 'GET_CMS_PACKAGES_START';
export const GET_CMS_PACKAGES_SUCCESS = 'GET_CMS_PACKAGES_SUCCESS';
export const GET_CMS_PACKAGES_FAIL = 'GET_CMS_PACKAGES_FAIL';

export const GET_BONUS_RECORDS_START = 'GET_BONUS_RECORDS_START';
export const GET_BONUS_RECORDS_SUCCESS = 'GET_BONUS_RECORDS_SUCCESS';
export const GET_BONUS_RECORDS_FAIL = 'GET_BONUS_RECORDS_FAIL';

export const GET_BONUS_RECORD_START = 'GET_BONUS_RECORD_START';
export const GET_BONUS_RECORD_SUCCESS = 'GET_BONUS_RECORD_SUCCESS';
export const GET_BONUS_RECORD_FAIL = 'GET_BONUS_RECORD_FAIL';

export const GET_BONUS_RECORD_HISTORY_START = 'GET_BONUS_RECORD_HISTORY_START';
export const GET_BONUS_RECORD_HISTORY_SUCCESS = 'GET_BONUS_RECORD_HISTORY_SUCCESS';
export const GET_BONUS_RECORD_HISTORY_FAIL = 'GET_BONUS_RECORD_HISTORY_FAIL';

export const GET_SUBSCRIBERS_LIST_START = 'GET_SUBSCRIBERS_LIST_START';
export const GET_SUBSCRIBERS_LIST_SUCCESS = 'GET_SUBSCRIBERS_LIST_SUCCESS';
export const GET_SUBSCRIBERS_LIST_FAIL = 'GET_SUBSCRIBERS_LIST_FAIL';

export const POST_ON_APPROVE_START = 'POST_ON_APPROVE_START';
export const POST_ON_APPROVE_SUCCESS = 'POST_ON_APPROVE_SUCCESS';
export const POST_ON_APPROVE_FAIL = 'POST_ON_APPROVE_FAIL';

export const PATCH_APPROVE_START = 'PATCH_APPROVE_START';
export const PATCH_APPROVE_SUCCESS = 'PATCH_APPROVE_SUCCESS';
export const PATCH_APPROVE_FAIL = 'PATCH_APPROVE_FAIL';

export const GET_BONUSES_PACKAGES_START = 'GET_BONUSES_PACKAGES_START';
export const GET_BONUSES_PACKAGES_SUCCESS = 'GET_BONUSES_PACKAGES_SUCCESS';
export const GET_BONUSES_PACKAGES_FAIL = 'GET_BONUSES_PACKAGES_FAIL';

export const GET_BONUS_PACKAGE_START = 'GET_BONUS_PACKAGE_START';
export const GET_BONUS_PACKAGE_SUCCESS = 'GET_BONUS_PACKAGE_SUCCESS';
export const GET_BONUS_PACKAGE_FAIL = 'GET_BONUS_PACKAGE_FAIL';

export const POST_BONUSES_PACKAGES_START = 'POST_BONUSES_PACKAGES_START';
export const POST_BONUSES_PACKAGES_SUCCESS = 'POST_BONUSES_PACKAGES_SUCCESS';
export const POST_BONUSES_PACKAGES_FAIL = 'POST_BONUSES_PACKAGES_FAIL';

export const PATCH_BONUSES_PACKAGE_START = 'PATCH_BONUSES_PACKAGE_START';
export const PATCH_BONUSES_PACKAGE_SUCCESS = 'PATCH_BONUSES_PACKAGE_SUCCESS';
export const PATCH_BONUSES_PACKAGE_FAIL = 'PATCH_BONUSES_PACKAGE_FAIL';

export const PATCH_BONUSES_PACKAGE_STATUS_START = 'PATCH_BONUSES_PACKAGE_STATUS_START';
export const PATCH_BONUSES_PACKAGE_STATUS_SUCCESS = 'PATCH_BONUSES_PACKAGE_STATUS_SUCCESS';
export const PATCH_BONUSES_PACKAGE_STATUS_FAIL = 'PATCH_BONUSES_PACKAGE_STATUS_FAIL';

export const DELETE_BONUSES_PACKAGE_START = 'DELETE_BONUSES_PACKAGE_START';
export const DELETE_BONUSES_PACKAGE_SUCCESS = 'DELETE_BONUSES_PACKAGE_SUCCESS';
export const DELETE_BONUSES_PACKAGE_FAIL = 'DELETE_BONUSES_PACKAGE_FAIL';

export const POST_UPLOAD_PACKAGE_IMAGE_START = 'POST_UPLOAD_PACKAGE_IMAGE_START';
export const POST_UPLOAD_PACKAGE_IMAGE_SUCCESS = 'POST_UPLOAD_PACKAGE_IMAGE_SUCCESS';
export const POST_UPLOAD_PACKAGE_IMAGE_FAIL = 'POST_UPLOAD_PACKAGE_IMAGE_FAIL';
